export interface EnumType {[s: number]: string}

export module EnumUtils {

    // Only works with numeric enums
    export function loopEnums(targetEnum: EnumType, block: (element: string, elementNo: number) => void) {
        for(const element in targetEnum) {
            const elementNo = Number(element)
            if(!isNaN(elementNo)) {
                block(element, elementNo)
            }
        }
    }

    // Works with both numeric and string enums
    export function iterateEnum(targetEnum: EnumType, callback: (value: any) => void) {
        for(const enumValue in targetEnum) {
            if(isNaN(Number(enumValue))) {
                callback(targetEnum[enumValue])
            }
        }
    }

    export function getLength(targetEnum: EnumType): number {
        const enumKeys = Object.keys(targetEnum)
        return enumKeys.filter((key) => isNaN(Number(key))).length
    }

    export function getEnumKey<EnumT, EnumTypeT>(enumValue: EnumT, enumType: EnumTypeT): keyof EnumTypeT {
        return enumType[enumValue as any] as keyof EnumTypeT
    }

    export function getEnumValue<EnumTypeT extends EnumType>(enumKeyOrValue: any, enumType: EnumTypeT): EnumTypeT[keyof EnumTypeT] | undefined {
        if(enumKeyOrValue == undefined) return undefined
        if(!isNaN(Number(enumKeyOrValue))) return enumType[Number(enumKeyOrValue)] !== undefined ? Number(enumKeyOrValue) as any : undefined
        return enumType[enumKeyOrValue] as any
    }

    export function getEnumKeys<EnumTypeT extends EnumType>(enumType: EnumTypeT): (keyof EnumTypeT)[] {
        return Object.keys(enumType).filter((key) => isNaN(Number(key))) as (keyof EnumTypeT)[]
    }

}
